import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "経営情報報告制度（貸借対照表）  設定", -1)
const _hoisted_2 = { class: "ml-3" }
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link active",
      id: "shisan-tab",
      "data-toggle": "tab",
      "aria-selected": "true",
      href: "#shisan-panel",
      role: "tab",
      "aria-controls": "shisan-panel"
    }, "資産")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "fusai-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#fusai-panel",
      role: "tab",
      "aria-controls": "fusai-panel"
    }, "負債")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "junshisan-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#junshisan-panel",
      role: "tab",
      "aria-controls": "junshisan-panel"
    }, "純資産")
  ])
], -1)
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = {
  class: "tab-pane fade show active",
  id: "shisan-panel",
  role: "tabpanel",
  "aria-labelledby": "shisan-tab"
}
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = {
  class: "tab-pane fade",
  id: "fusai-panel",
  role: "tabpanel",
  "aria-labelledby": "fusai-tab"
}
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = {
  class: "tab-pane fade",
  id: "junshisan-panel",
  role: "tabpanel",
  "aria-labelledby": "junshisan-tab"
}
const _hoisted_11 = {
  key: 0,
  class: "mt-3 ml-3 row align-items-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "mb-0",
    style: {"font-size":"20px"}
  }, "出力設定")
], -1)
const _hoisted_13 = { class: "ml-3 form-check form-check-inline" }
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "shushikin"
}, "出資金", -1)
const _hoisted_16 = { class: "form-check form-check-inline" }
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "kikin"
}, "基金", -1)
const _hoisted_19 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_taishaku_taisho_setting_item = _resolveComponent("taishaku-taisho-setting-item")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_loading_button, {
          color: "primary",
          loading: _ctx.loading,
          disabled: _ctx.hasError,
          onClick: _ctx.onClickRegister
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shisanItems, (item) => {
                return (_openBlock(), _createBlock(_component_taishaku_taisho_setting_item, {
                  key: item.item.id,
                  item: item,
                  onChangeInput: _cache[0] || (_cache[0] = (v) => _ctx.onChangeInput(_ctx.taishakuTaishoElementTypeType.Shisan, v))
                }, null, 8, ["item"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fusaiItems, (item) => {
                return (_openBlock(), _createBlock(_component_taishaku_taisho_setting_item, {
                  key: item.item.id,
                  item: item,
                  onChangeInput: _cache[1] || (_cache[1] = (v) => _ctx.onChangeInput(_ctx.taishakuTaishoElementTypeType.Fusai, v))
                }, null, 8, ["item"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.corporationType === _ctx.corporationTypeType.Type1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      value: _ctx.outputFundTypeType.Shushikin,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.outputFundType) = $event)),
                      id: "shushikin"
                    }, null, 8, _hoisted_14), [
                      [_vModelRadio, _ctx.outputFundType]
                    ]),
                    _hoisted_15
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      value: _ctx.outputFundTypeType.Kikin,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.outputFundType) = $event)),
                      id: "kikin"
                    }, null, 8, _hoisted_17), [
                      [_vModelRadio, _ctx.outputFundType]
                    ]),
                    _hoisted_18
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.junShisanItems, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.item.id
                }, [
                  ((_ctx.corporationType !== _ctx.corporationTypeType.Type1 ||
                          (_ctx.corporationType === _ctx.corporationTypeType.Type1 &&
                            (
                             !(_ctx.outputFundType === _ctx.taishakuTaishoKmkTypeType.Shushikin && item.item.kmkType === _ctx.taishakuTaishoKmkTypeType.Kikin) &&
                             !(_ctx.outputFundType === _ctx.taishakuTaishoKmkTypeType.Kikin && item.item.kmkType === _ctx.taishakuTaishoKmkTypeType.Shushikin)
                            )
                          )
                        ))
                    ? (_openBlock(), _createBlock(_component_taishaku_taisho_setting_item, {
                        key: 0,
                        item: item,
                        onChangeInput: _cache[4] || (_cache[4] = (v) => _ctx.onChangeInput(_ctx.taishakuTaishoElementTypeType.Junshisan, v))
                      }, null, 8, ["item"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}